import { WEB_SHOW_DEAL_BANNER_AS_DISCOUNT } from "../constants";
import getFeatures from "./getFeatures";

const getShowDealBannerAsDiscount = state => {
  const {
    [WEB_SHOW_DEAL_BANNER_AS_DISCOUNT]: showDealBannerAsDiscount
  } = getFeatures(state);

  return !!showDealBannerAsDiscount;
};

export default getShowDealBannerAsDiscount;
